import promotion_tiles from "./promotion_tiles"

import Search from "./Search"
import Footer from "./Footer"
import Promotions from "./Promotions"
import ContactUs from "./ContactUs"
import Login from "./Login"
import Signup from "./Signup"
import Activate from "./Activate"
import Businesses from "./Businesses"
import Adverts from "./Adverts"
import Categories from "./Categories"
import Shared from "./Shared"
import Locations from "./Locations"
import Holidays from "./Holidays"
import NewsLetterSubscriptions from "./NewsLetterSubscriptions"

export default {
    name: "ServerClient",
    Home: {
        /*
            var query = {
                old_password: "",
                new_password: "",
                phone_number: ""
            }
        */
        /* eslint-disable no-unused-vars */
        get_promotion_tiles(query, success, fail) {
            var data = promotion_tiles.items;
            success(data);
        }
    },
    Search,
    Footer,
    Promotions,
    ContactUs,
    Login,
    Businesses,
    Adverts,
    Categories,
    Signup,
    Activate,
    Shared,
    Locations,
    Holidays,
    NewsLetterSubscriptions,
    set_temp_rate(value){
        localStorage.setItem("temp_business_rate",value);
    },
    get_temp_rate(){
        var x = localStorage.getItem("temp_business_rate");
        if(x){
            x = parseFloat(x);
        }else{
            x = 0;
        }
        return x;
    },
    clear_temp_rate(){
        localStorage.removeItem("temp_business_rate");
        localStorage.removeItem("has_just_rate_logged_in");
    },
    get_has_just_rate_logged_in(){
        var x = localStorage.getItem("has_just_rate_logged_in");
        if(x){
            x = x.toLowerCase();
        }else{
            x = "";
        }
        return x;
    },
    set_has_just_rate_logged_in(value){
        localStorage.setItem("has_just_rate_logged_in",value);
    },
}